import { render, staticRenderFns } from "./RunningCampaignsTable.vue?vue&type=template&id=009ed3fe&scoped=true"
import script from "./RunningCampaignsTable.vue?vue&type=script&lang=ts"
export * from "./RunningCampaignsTable.vue?vue&type=script&lang=ts"
import style0 from "./RunningCampaignsTable.vue?vue&type=style&index=0&id=009ed3fe&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009ed3fe",
  null
  
)

export default component.exports